import {Patient} from "./patient.model";

export class HticResults {

  mani1: number;
  mani3: number;
  mani5: number;
  ser1a: number;
  ser1b: number;
  ser2a: number;
  ser2b: number;

  constructor(patient: Patient) {
    this.initResults(patient)
  }

  initResults(patient: Patient) {
    const c = 0.2;
    this.mani1 = Math.round(patient.weight);
    this.mani3 = (patient.weight / c);
    this.mani5 = Math.floor((60 / 20) * patient.weight / c);
    this.ser1a = 6.5 * patient.weight;
    this.ser1b = 10 * patient.weight;
    this.ser2a = 0.1 * patient.weight;
    this.ser2b = patient.weight;
  }
}



// WEBPACK FOOTER //
// ./src/models/htic-results.model.ts